<template>
  <card>
    <list
      v-if="$store.state.user['is_root']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :setImport="true"
      :exportFields="exportFields"
      :staticFilters="staticFilters"
      :setLink="setLink"
      :openItem="false"
      :fields="fields"
      :filters="filters"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :dateFilter="dateFilter"
    />
    <h4 v-else>{{ "no_acccess" | setText("НЕТ ДОСТУПА") }}</h4>
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        "CB ID": {
          field: "order",
          callback: (val) => {
            try {
              return val.id;
            } catch (error) {
              return "-";
            }
          },
        },
        "UZUM ID": {
          field: "exchange_additional_id",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return "-";
            }
          },
        },

        "Загружен акт": {
          field: "act",
          callback: (val) => {
            return val ? "Да" : "Нет";
          },
        },
        "Загружено фото клиента": {
          field: "client_product",
          callback: (val) => {
            return val ? "Да" : "Нет";
          },
        },

        Локация: {
          field: "shop.name",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return "";
            }
          },
        },
        Оператор: {
          field: "user.name",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return "";
            }
          },
        },
        "Номер оператора": {
          field: "user.phone",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return "";
            }
          },
        },
        "Подписанный акт": {
          field: "act",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return "";
            }
          },
        },
        "Фото клиента": {
          field: "client_product",
          callback: (val) => {
            try {
              return val;
            } catch (error) {
              return "";
            }
          },
        },
        Дата: {
          field: "created_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                let date = new Date(val);
                return date.toLocaleString();
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
      },
      filters: [
        {
          key: "shop",
          title: "Фильтр по торговым точкам",
          titleKey: "shop_filter",
          field_key: "shop",
          selectKey: "name",
        },
        {
          key: "organization",
          title: "Фильтр по организациям",
          titleKey: "organization_filter",
          field_key: "organization",
          selectKey: "name",
        },
      ],
      staticFilters: [
        {
          title: "Статус выгрузки",
          key: "no_load",
          default: "0",
          items: [
            {
              id: "0",
              title: "Показать все",
            },
            {
              id: "1",
              title: "Не загружен акт/фото",
            },
            {
              id: "2",
              title: "Загружен акт/фото",
            },
          ],
        },
      ],
      params: {},
      val: [],
      modalCreate: "role",
      fields: [],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "transactions",
      setLink: "transactions",
      columns: [
        {
          key: "exchange_additional_id",
          title: "PID2",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "act_original",
          title: "Акт оригинал",
          checkbox: false,
          control: false,
          link: true,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "act",

          title: "Акт",
          checkbox: false,
          control: false,
          link: true,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "client_product",

          title: "Фото",
          checkbox: false,
          control: false,
          link: true,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "is_act_verified",
          title: "Акт (RE)",
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "is_photo_verified",
          title: "Фото (RE)",
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        // {
        //   key: "is_imei_verified",
        //   title: "IMEI проверено",
        //   control: false,
        //   align: "left",
        //   timer: false,
        //   detail: false,
        // },

        {
          key: "partner",
          title: "Партнер",
          object: "name",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "shop",
          title: "Локация",
          object: "name",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "user",
          title: "Оператор",
          object: "name",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "user",
          title: "Номер оператора",
          object: "phone",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "order",
          title: "Заказ",
          object: "id",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "created_at",
          title: "",
          align: "right",
          dateTimeFormat: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
